import { Dispatch } from 'redux'
import { StartMainMapDispatchReturnType } from './types/StartMainMapDispatchReturnType'

export const StartMainMapDispatch = (
  _dispatch: Dispatch
): StartMainMapDispatchReturnType => {
  return {
  }
}
